import './BimService.css';
import Footer from '../../components/footer/Footer';
import hexes from '../../assets/img/hexes';
import Translator from "../../translates/Translator";
import usePageMeta from '../../hooks/usePageMeta';

const BimService = () => {
    const t = Translator();
    usePageMeta(`${t("bim-hero-title")} | IKA DATA`, t("bim-hero-subtitle"));

    return (
        <div className=''>
            <div className="header-filler"></div>
            <div className='bim'>
                <section class="hero-section shadow-8-2">
                    <div class="container">
                        <h1 class="hero-title mb-5 text-main">{t('bim-hero-title')}</h1>
                        <p class="hero-subtitle gray">
                            {t('bim-hero-subtitle')}
                        </p>
                    </div>
                </section>

                <section class="services-grid container">
                    <div class="service-card row">
                        <div class="feature-icon col-2">
                            <i className={`fa-solid fa-pen-ruler `}></i>
                        </div>
                        <h3 class="service-title col-10 text-main">{t('bim-service-title1')}</h3>
                        <p class="service-description gray">
                            {t('bim-service-desc1')}
                        </p>
                    </div>

                    <div class="service-card row">
                        <div class="feature-icon col-2">
                            <i className={`fa-solid fa-magnifying-glass `}></i>
                        </div>
                        <h3 class="service-title col-10 text-main">{t('bim-service-title2')}</h3>
                        <p class="service-description gray">
                            {t('bim-service-desc2')}
                        </p>
                    </div>

                    <div class="service-card row">
                        <div class="feature-icon col-2">
                            <i className={`fa-solid fa-chart-gantt `}></i>
                        </div>
                        <h3 class="service-title col-10 text-main">{t('bim-service-title3')}</h3>
                        <p class="service-description gray">
                            {t('bim-service-desc3')}
                        </p>
                    </div>

                    <div class="service-card row">
                        <div class="feature-icon col-2">
                            <i className={`fa-solid fa-clipboard-list `}></i>
                        </div>
                        <h3 class="service-title col-10 text-main">{t('bim-service-title4')}</h3>
                        <p class="service-description gray">
                            {t('bim-service-desc4')}
                        </p>
                    </div>

                    <div class="service-card row">
                        <div class="feature-icon col-2">
                            <i className={`fa-solid fa-graduation-cap`}></i>
                        </div>
                        <h3 class="service-title col-10 text-main">{t('bim-service-title5')}</h3>
                        <p class="service-description gray">
                            {t('bim-service-desc5')}
                        </p>
                    </div>

                    <div class="service-card row">
                        <div class="feature-icon col-2">
                            <i className={`fa-solid fa-cloud `}></i>
                        </div>
                        <h3 class="service-title col-10 text-main">{t('bim-service-title6')}</h3>
                        <p class="service-description gray">
                            {t('bim-service-desc6')}
                        </p>
                    </div>
                </section>

                <section class="ar-tools-section shadow-8-2">
                    <div class="container">
                        <div class="ar-content">
                            <h2 class="ar-title">
                                <i class="fa-solid fa-vr-cardboard me-3"></i>
                                {t('bim-ar-title')}
                            </h2>
                            <p class="ar-description">
                                {t('bim-ar-subtitle')}
                            </p>

                            <div class="ar-features">
                                <div class="ar-feature">
                                    <h4>{t('bim-ar-title1')}</h4>
                                    <p>{t('bim-ar-desc1')}</p>
                                </div>

                                <div class="ar-feature">
                                    <h4>{t('bim-ar-title2')}</h4>
                                    <p>{t('bim-ar-desc2')}</p>
                                </div>

                                <div class="ar-feature">
                                    <h4>{t('bim-ar-title3')}</h4>
                                    <p>{t('bim-ar-desc3')}</p>
                                </div>

                                <div class="ar-feature">
                                    <h4>{t('bim-ar-title4')}</h4>
                                    <p>{t('bim-ar-desc4')}</p>
                                </div>

                                <div class="ar-feature">
                                    <h4>{t('bim-ar-title5')}</h4>
                                    <p>{t('bim-ar-desc5')}</p>
                                </div>

                                <div class="ar-feature">
                                    <h4>{t('bim-ar-title6')}</h4>
                                    <p>{t('bim-ar-desc6')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="features-section">
                    <div class="container">
                        <h2 class="section-title">{t('bim-feat-title')}</h2>
                        <div class="features-list">
                            <div class="feature-item">
                                <div class="feature-icon">✓</div>
                                <div class="feature-content">
                                    <h3>{t('bim-feat-title1')}</h3>
                                    <p>{t('bim-feat-desc1')}</p>
                                </div>
                            </div>

                            <div class="feature-item">
                                <div class="feature-icon">✓</div>
                                <div class="feature-content">
                                    <h3>{t('bim-feat-title2')}</h3>
                                    <p>{t('bim-feat-desc2')}</p>
                                </div>
                            </div>

                            <div class="feature-item">
                                <div class="feature-icon">✓</div>
                                <div class="feature-content">
                                    <h3>{t('bim-feat-title3')}</h3>
                                    <p>{t('bim-feat-desc3')}</p>
                                </div>
                            </div>

                            <div class="feature-item">
                                <div class="feature-icon">✓</div>
                                <div class="feature-content">
                                    <h3>{t('bim-feat-title4')}</h3>
                                    <p>{t('bim-feat-desc4')}</p>
                                </div>
                            </div>

                            <div class="feature-item">
                                <div class="feature-icon">✓</div>
                                <div class="feature-content">
                                    <h3>{t('bim-feat-title5')}</h3>
                                    <p>{t('bim-feat-desc5')}</p>
                                </div>
                            </div>

                            <div class="feature-item">
                                <div class="feature-icon">✓</div>
                                <div class="feature-content">
                                    <h3>{t('bim-feat-title6')}</h3>
                                    <p>{t('bim-feat-desc6')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
            <Footer />
        </div >
    );
}

export default BimService;